module.exports = __webpack_public_path__ + "static/media/end-call.fb4e830c.svg";